export default __webpack_public_path__ + "static/matilda-banner-e533e561dc5267ddac9b305d754a52f3.webp";